import { AutoComplete } from "antd";
import classNames from "classnames";
import Label from "../Label";

const AutoCompleteInput = ({
  label,
  errors,
  icon,
  touched,
  required,
  ...rest
}) => (
  <div
    className={classNames("autocomplete__lmf", {
      __error: touched && errors,
    })}
  >
    <Label label={label} icon={icon} required={required} />
    <div className={`autocomplete__lmf--field`}>
      <AutoComplete
        className={classNames({ "disable--input": rest.disabled })}
        {...rest}
      />
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  </div>
);

export default AutoCompleteInput;
